export const KEY_PREFIX = { MEMORY_API: "apt_memory_" } as const;
